import React from 'react'
import { HashRouter, Route, Routes, Outlet, Link, Navigate } from 'react-router-dom'
import { AliveScope, KeepAlive } from 'react-activation'
import routeList from '../config/routeMap'
import Home from '../views/home'
import NotFound from '../views/NotFound'
// import Layout from '../views/layout'
export default function Router() {
    return (
        <HashRouter>
            <AliveScope>
                <Routes>
                    {
                        routeList.map(route => {
                            const { cacheFlag, path, component } = route
                            return (
                                <Route 
                                    key={path} 
                                    path={path} 
                                    element={ 
                                        cacheFlag ? (
                                            <KeepAlive id={path} saveScrollPosition="screen">
                                                {component}
                                            </KeepAlive>
                                        ) : component
                                    } 
                                />
                            )
                        })
                    }
                    <Route 
                        path="/" 
                        element={
                            <KeepAlive id="home" saveScrollPosition="screen">
                                <Home />
                            </KeepAlive>
                        } 
                    />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </AliveScope>
        </HashRouter>
    )
}

function Layout() {
    return (
        <div className="app-container">
            {/* <header>
                <Link to="/">Home</Link>
                <Link to="/demo1">Demo1</Link>
                <Link to="/demo2">Demo2</Link>
                <Link to="/demo3">Demo3</Link>
            </header> */}

            <main>
                <Outlet />
            </main>
        </div>
    );
}
